import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingImage from "../../../comum/components/LoadingImage";
import Footer from "../../../comum/components/Footer";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { CollapseItemTableIndicator } from "../../../comum/components/CollapseItemTableIndicator";
import FiltrosBooking from "./FiltrosBooking";
import DetalhesBooking from "./DetalhesBooking";
import CardBooking from "./CardBooking";
import {Col, Container, Row} from "reactstrap";
import { buscaFiltrarVazio } from '../../../../utils/mensagens';
import FooterContent from "../../../comum/components/FooterContent";
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";


@inject("store")
@observer
export class TabelaBooking extends Component{

    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        window.addEventListener('scroll', HeaderTableFixed);
    }

    render() {
        const capacidade = this.controller.capacidade;
        const containersAgendados = this.controller.containerAgendados;
        let lista =  this.controller.bookingLista && this.controller.bookingLista.length > 0 ?  this.controller.bookingLista : [];
        let operacoes = this.controller.operacoes && this.controller.operacoes.length > 0 ? this.controller.operacoes : [];
        let loading = this.controller.loading;

        //Se a lista tiver somente um resultado, mostrar a row de detalhes já expandida.
        let toExpand=null;
        if(lista.length === 1){
            toExpand = lista[0].booking.Nbr;
        }
        const detalhesRow = {
            renderer: row => (
                <Row>
                    <DetalhesBooking titulo="Capacidade" campos={capacidade} row={row.itens}/>
                    <DetalhesBooking titulo="Containers" campos={containersAgendados} 
                                                           row={row.containers} 
                                                           operacaoBooking ={row.booking.VesselVisit} 
                                                           booking = {row.booking.Nbr}
                    />
                </Row>
            ),
            expanded: [toExpand],
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            expandColumnPosition: 'right',
            expandByColumnOnly: true,
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnRenderer: ({ expanded }) => {
                if (expanded) {
                    return (
                        <CollapseItemTableIndicator expanded={expanded}/>
                    );
                }
                return (
                    <CollapseItemTableIndicator expanded={expanded}/>
                );
            },
            
        };

        if(this.controller.loading) {
            return(
                <Row>
                    <Col>
                        <LoadingImage />
                    </Col>
                </Row>
            )
        } else {
            return (
                <Container fluid className="tabela-container">
                    { !this.controller.filtrado
                        ? <Row>
                            <Col xs={12}>
                                <span className="mensagem-filtrar">
                                    {buscaFiltrarVazio}
                                </span>
                            </Col>
                        </Row>
                        : 
                        <InfiniteScroll
                            dataLength={this.controller.itens.length}
                            next={() => this.controller.loadNextTurn()}
                            hasMore={this.controller.hasMore}
                            loader={<LoadingImage />}
                        >
                            <ToolkitProvider
                                keyField="booking.Nbr"
                                data={[...this.controller.itens]}
                                columns={[...this.controller.colunas]} >
                                {props => (
                                    <div>
                                        
                                        {window.innerWidth > 991 ?
                                            <div id="tableHeaderFixed">
                                          
                                                <BootstrapTable
                                                    bootstrap4
                                                    striped
                                                    bordered={false}
                                                    noDataIndication={() =>
                                                        loading ?
                                                        <LoadingImage/> : this.controller.tableMessage
                                                    }
                                                    classes="tabela"
                                                    expandRow={detalhesRow}
                                                    //pagination={ paginationFactory() }
                                                    {...props.baseProps}
                                                />
                                            </div>
                                            :
                                            
                                                <Row>
                                                    
                                                    {loading ?
                                                    <LoadingImage/>
                                                    :
                                                    lista.map((card, x) => (
                                                        <CardBooking
                                                            key={x}
                                                            data={card}
                                                            id={x}
                                                            colunas={[...this.controller.colunas]}
                                                            capacidade={[...this.controller.capacidade]}
                                                            containerAgendados={[...this.controller.containerAgendados]}
                                                            titulo="booking.Nbr"
                                                        />
                                                    )) }
                                                </Row>
                                            }
                                    </div>)
                                }
                            </ToolkitProvider>
                        </InfiniteScroll>
                    }
    
                    <Footer>
                        {this.controller.filtrado && <FooterContent>
                            {this.controller.total !== null &&
                                <div className="justify-content-between">
                                    <div><b>{this.controller.itens.length}</b> {this.controller.total === 1 ? 'registro' : 'registros'} - <a
                                        onClick={() => this.controller.carregarLista()}>Atualizar Lista</a>
                                    </div>
                                </div>
                            }
                        </FooterContent>}
    
                    </Footer>
                </Container>
            );
        }

    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/booking/components/TabelaBooking.js